import { render, staticRenderFns } from "./CrossSellOfferSaleBase.vue?vue&type=template&id=9592cb18&scoped=true"
import script from "./CrossSellOfferSaleBase.vue?vue&type=script&lang=js"
export * from "./CrossSellOfferSaleBase.vue?vue&type=script&lang=js"
import style0 from "./CrossSellOfferSaleBase.vue?vue&type=style&index=0&id=9592cb18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9592cb18",
  null
  
)

export default component.exports